<template>
  <div class="md-primary">
    <div class="md-primary__value">{{ value }}</div>
    <div class="md-primary__label">{{ label }}</div>
    <!-- Comparison pill renders only when a delta is provided (currently off) -->
    <div v-if="delta != null" class="md-primary__delta" :class="delta >= 0 ? 'is-up' : 'is-down'">
      <i :class="delta >= 0 ? 'fa-solid fa-arrow-trend-up' : 'fa-solid fa-arrow-trend-down'"></i>
      {{ Math.abs(delta).toFixed(1) }}% {{ $t('mobileDash.vsPrevious') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MdPrimaryKpi',
  props: {
    value: { type: String, required: true },
    label: { type: String, required: true },
    delta: { type: Number, default: null },
  },
};
</script>

<style scoped>
.md-primary {
  padding: 0.85rem 0.5rem 0.95rem;
  margin-bottom: 0.65rem;
  text-align: center;
  background: linear-gradient(135deg, rgba(115, 103, 240, 0.1) 0%, rgba(0, 207, 232, 0.07) 100%);
  border: 1px solid rgba(115, 103, 240, 0.22);
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(115, 103, 240, 0.08), 0 8px 18px rgba(115, 103, 240, 0.14);
}
.dark-layout .md-primary {
  background: linear-gradient(135deg, rgba(115, 103, 240, 0.18) 0%, rgba(0, 207, 232, 0.1) 100%);
  border-color: rgba(115, 103, 240, 0.35);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.28), 0 8px 18px rgba(0, 0, 0, 0.24);
}
.md-primary__value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: var(--md-strong, #24292f);
  white-space: nowrap;
}
/* Full amounts get long — keep them on one line on narrow phones */
@media (max-width: 380px) {
  .md-primary__value { font-size: 25px; }
}
.md-primary__label {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6a5fe0;
}
.dark-layout .md-primary__label {
  color: #9d94f5;
}
.md-primary__delta {
  margin-top: 6px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
}
.md-primary__delta.is-up { color: #1f9d61; background: rgba(31, 157, 97, 0.09); }
.md-primary__delta.is-down { color: #d64545; background: rgba(214, 69, 69, 0.09); }
.md-primary__delta--none { color: var(--md-muted, #8a919c); background: rgba(138, 145, 156, 0.09); }

.dark-layout .md-primary { --md-strong: #d0d2d6; }
</style>
